import type { ChatCycle } from "./types.js";

// CYCLES walk the four labeled steps (orient → search → open → audit) on
// geo-index, so the animation literally demonstrates the progressive-disclosure
// surface described by the cost-card legend on the GEOx solutions page.
export const GEOX_CYCLES: ChatCycle[] = [
  {
    server: "geo-index · orient",
    user: "What's in the GEO index?",
    tool: "corpus_overview",
    args: [],
    result: {
      kind: "rows",
      rows: [
        { accession: "studies", title: "curated GEO series", meta: "42,559" },
        { accession: "samples", title: "validated, ontology-mapped", meta: "1.24M" },
        { accession: "contrasts", title: "structured case/control", meta: "120,589" },
      ],
      chip: "~200 tokens",
    },
    assistant:
      "42,559 studies · 1.24M validated samples · 120,589 structured contrasts. What do you want to drill into?",
  },
  {
    server: "geo-index · search",
    user: "Find Alzheimer brain case/control transcriptomes.",
    tool: "search_studies",
    args: [
      { k: "disease", v: '"Alzheimer disease"' },
      { k: "tissue", v: '"brain"' },
      { k: "contrast_type", v: '"case_control"' },
    ],
    result: {
      kind: "bars",
      rows: [
        { accession: "GSE5281", title: "Prefrontal cortex AD vs CTR", cases: 87, controls: 74 },
        { accession: "GSE48350", title: "Multi-region postmortem AD", cases: 173, controls: 80 },
        { accession: "GSE36980", title: "Temporal cortex AD", cases: 33, controls: 47 },
      ],
      chip: "~50 / result",
    },
    assistant:
      "3 of 18 matched studies — all curated case/control with direct AD vs control evidence. Open one?",
  },
  {
    server: "geo-index · open",
    user: "Open GSE5281.",
    tool: "study_detail",
    args: [{ k: "study_id", v: '"GSE5281"' }],
    result: {
      kind: "rows",
      rows: [
        { accession: "organism", title: "Homo sapiens", meta: "NCBITaxon:9606" },
        { accession: "platform", title: "Affymetrix HG-U133 Plus 2.0", meta: "GPL570" },
        { accession: "contrasts", title: "AD vs control (prefrontal cortex)", meta: "direct" },
      ],
      chip: "~500+ / record",
    },
    assistant:
      "Postmortem prefrontal cortex, 161 samples on GPL570. One direct AD vs CTR contrast available.",
  },
  {
    server: "geo-index · audit",
    user: "Why was GSM119615 labeled Alzheimer?",
    tool: "sample_evidence",
    args: [{ k: "sample_id", v: '"GSM119615"' }],
    result: {
      kind: "rows",
      rows: [
        { accession: "raw", title: "disease state: Alzheimer’s disease", meta: "submitter tag" },
        { accession: "mapped", title: "Alzheimer disease", meta: "MONDO:0004975" },
      ],
      chip: "direct evidence",
    },
    assistant: "Raw submission tag → MONDO:0004975. Direct extraction, no inference required.",
  },
];
